import * as React from "react";
import type { SVGProps } from "react";
const SvgKtvHollowcandlesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="ktv_hollowcandles_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M362.667 128a42.667 42.667 0 1 0-85.334 0v87.083a128 128 0 0 0-106.666 126.25v341.334a128 128 0 0 0 106.666 126.25V896a42.667 42.667 0 1 0 85.334 0v-87.083a128 128 0 0 0 106.666-126.25V341.333a128 128 0 0 0-106.666-126.25V128zm-21.334 597.333h-42.666a42.667 42.667 0 0 1-11.648-1.621L384 669.867v12.8a42.667 42.667 0 0 1-42.667 42.666zm-85.333-384a42.667 42.667 0 0 1 42.667-42.666h42.666a42.667 42.667 0 0 1 11.648 1.621L256 354.133v-12.8zm128 39.339v43.179l-128 76.8v-48.896l128-71.083zM256 643.328v-43.179l128-76.8v48.896l-128 71.083zm490.667-429.995a42.667 42.667 0 1 0-85.334 0v87.083a128 128 0 0 0-106.666 126.25V640a128 128 0 0 0 106.666 126.25v87.083a42.667 42.667 0 1 0 85.334 0v-87.082A128 128 0 0 0 853.333 640V426.667a128 128 0 0 0-106.666-126.251v-87.083zm-21.334 469.334h-42.666A42.667 42.667 0 0 1 640 640V426.667A42.667 42.667 0 0 1 682.667 384h42.666A42.667 42.667 0 0 1 768 426.667V640a42.667 42.667 0 0 1-42.667 42.667z"
    />
  </svg>
);
export default SvgKtvHollowcandlesIcon;
